const hexCodes = [
  '#F7977A',
  '#C4DF9B',
  '#6ECFF6',
  '#FFF79A',
  '#A187BE',
  '#A2D39C',
  '#7EA7D8',
  '#F49AC2',
  '#FDC68A',
  '#82CA9D',
  '#8493CA',
  '#BC8DBF',
  '#F9AD81',
  '#7BCDC8',
  '#8882BE',
  '#F6989D'
];

export default hexCodes;
